import {
  Typography,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Drawer,
  Divider,
  IconButton,
} from "@mui/material";
import { Item } from "../../utils/sharedTypes";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SupportDisplay from "./SupportDisplay";
import HardwareDisplay from "./HardwareDisplay";
import LicensesDisplay from "./LicensesDisplay";
import RmaDisplay from "./RmaDisplay";
import { ChevronRight } from "@mui/icons-material";
import useStyles from "./orderLinkedItemsStyles";

interface Props {
  orders: Item[];
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const OrderLinkedItemsDisplay = ({ orders, open, setOpen }: Props) => {
  const classes = useStyles();
  return (
    <Drawer
      anchor="right"
      variant="persistent"
      open={open}
      className={classes.drawer}
      classes={{ paper: classes.drawerPaper }}
    >
      <div className={classes.drawerHeader}>
        <IconButton
          onClick={() => {
            setOpen(false);
          }}
          size="large">
          <ChevronRight />
        </IconButton>
      </div>
      {orders.length < 1 ? (
        <Typography>No orders selected.</Typography>
      ) : (
        <>
          <Accordion square={true} elevation={0}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography>Support Purchases</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <SupportDisplay orders={orders} />
            </AccordionDetails>
          </Accordion>
          <Divider />
          <Accordion square={true} elevation={0}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography>Hardware</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <HardwareDisplay orders={orders} />
            </AccordionDetails>
          </Accordion>
          <Divider />
          <Accordion square={true} elevation={0}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography>Licenses</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <LicensesDisplay orders={orders} />
            </AccordionDetails>
          </Accordion>
          <Divider />
          <Accordion square={true} elevation={0}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography>RMAs</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <RmaDisplay orders={orders} />
            </AccordionDetails>
          </Accordion>
        </>
      )}
    </Drawer>
  );
};

export default OrderLinkedItemsDisplay;
